import { Controller } from "@hotwired/stimulus"

// Atualiza plano exibido e plan_id conforme o botão que abriu o modal (Bootstrap: event.relatedTarget).
export default class extends Controller {
  static targets = ["planId", "planName"]

  connect() {
    this.onShow = this.handleShow.bind(this)
    this.element.addEventListener("show.bs.modal", this.onShow)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.onShow)
  }

  handleShow(event) {
    const btn = event.relatedTarget
    if (!btn || !btn.dataset.planId) return

    if (this.hasPlanIdTarget) this.planIdTarget.value = btn.dataset.planId
    if (this.hasPlanNameTarget) {
      this.planNameTarget.textContent = btn.dataset.planName || "—"
    }
  }
}
